import React, { useEffect, useState } from 'react';
import { Tour } from 'antd';

const STORAGE_KEY = 'leadops_onboarding_done';

export const useOnboarding = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
      setOpen(true);
    } catch {
      // localStorage disabled
    }
  }, []);

  const finish = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
    setOpen(false);
  };

  return { open, finish };
};

const steps = [
  {
    title: 'Enter domain',
    description: 'Type a domain or full URL to look up.',
    target: () => document.querySelector('#leadops-domain-input') as HTMLElement,
    placement: 'right' as const,
  },
  {
    title: 'Check BOTH',
    description: 'Click to fetch Similarweb traffic data and Monday CRM matches in one go.',
    target: () => document.querySelector('#leadops-check-both') as HTMLElement,
    placement: 'top' as const,
  },
  {
    title: "You're all set",
    description: 'Once data loads, use Create or Reassign to manage leads. Open in Similarweb for deep-dive.',
    target: () => document.querySelector('#leadops-search-card') as HTMLElement,
    placement: 'bottom' as const,
    arrow: false,
  },
];

type OnboardingTourProps = {
  open: boolean;
  onClose: () => void;
};

export const OnboardingTour: React.FC<OnboardingTourProps> = ({ open, onClose }) => (
  <Tour
    open={open}
    onClose={onClose}
    steps={steps}
    gap={{ offset: 8 }}
    type="default"
    animated={false}
    scrollIntoViewOptions={false}
    indicatorsRender={(current, total) => (
      <span style={{ marginLeft: 8, color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>
        {current + 1} / {total}
      </span>
    )}
  />
);
